export default __webpack_public_path__ + "static/media/4.b3d2317f.webp";